enum ResidentTypeEnum {
    NonResident = 'NON_RESIDENT',
    Resident = 'RESIDENT',
}

export default ResidentTypeEnum;
